import { render, staticRenderFns } from "./main_menu.vue?vue&type=template&id=4d4d0a65&"
import script from "./main_menu.vue?vue&type=script&lang=js&"
export * from "./main_menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4d4d0a65', component.options)
    } else {
      api.reload('4d4d0a65', component.options)
    }
    module.hot.accept("./main_menu.vue?vue&type=template&id=4d4d0a65&", function () {
      api.rerender('4d4d0a65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/menu_common/main_menu.vue"
export default component.exports